/** NOTIF1 T12: /parametres/:section — one URL per settings section (N9, N26). */
export const SETTINGS_PATH = '/parametres';

export const SETTINGS_SECTION = Object.freeze({
  PROFILE: 'profil',
  SECURITY: 'securite',
  PAYMENTS: 'paiements',
  URSSAF: 'urssaf',
  NOTIFICATIONS: 'notifications',
  LESSONS: 'cours',
  FAMILY_PORTAL: 'portail-familles',
  TEACHER_PAGE: 'ma-page',
  REFERRAL: 'parrainage',
});

/** Menu order. */
export const SETTINGS_SECTIONS = Object.freeze([
  SETTINGS_SECTION.PROFILE,
  SETTINGS_SECTION.SECURITY,
  SETTINGS_SECTION.PAYMENTS,
  SETTINGS_SECTION.URSSAF,
  SETTINGS_SECTION.NOTIFICATIONS,
  SETTINGS_SECTION.LESSONS,
  SETTINGS_SECTION.FAMILY_PORTAL,
  SETTINGS_SECTION.TEACHER_PAGE,
  SETTINGS_SECTION.REFERRAL,
]);

export const settingsPath = (section) => (section ? `${SETTINGS_PATH}/${section}` : SETTINGS_PATH);

export const SETTINGS_API = Object.freeze({
  NOTIFICATION_PREFS: '/settings/notification-prefs',
  MISSION_TERM: '/settings/mission-term',
});

/** NEW1: names the teacher can pick for « missions » (backend lesson_settings_defaults.MISSION_TERMS). */
export const MISSION_TERMS = Object.freeze(['mission', 'devoir', 'exercice', 'travail']);
export const DEFAULT_MISSION_TERM = 'mission';

/** Editable teacher_info fields, in form order. */
export const PROFILE_FIELDS = Object.freeze([
  { key: 'first_name', type: 'text', autoComplete: 'given-name' },
  { key: 'last_name', type: 'text', autoComplete: 'family-name' },
  { key: 'phone', type: 'tel', autoComplete: 'tel' },
  { key: 'company_name', type: 'text', autoComplete: 'organization' },
  { key: 'siret', type: 'text', inputMode: 'numeric' },
  { key: 'sap_agreement', type: 'text' },
  { key: 'address_full', type: 'text', autoComplete: 'street-address' },
  { key: 'postal_code', type: 'text', autoComplete: 'postal-code', inputMode: 'numeric' },
  { key: 'city', type: 'text', autoComplete: 'address-level2' },
  { key: 'deduction_pct', type: 'number', min: 0, max: 100 },
]);

/** Mirror of backend profile_service.REQUIRED_PROFILE_FIELDS (billing blocker). */
export const PROFILE_REQUIRED_FIELDS = Object.freeze([
  'phone', 'siret', 'company_name', 'address_full', 'postal_code', 'city',
]);
